import BaseApiService from '@/services/common/api/baseApiService';

class AccountService extends BaseApiService {
  validateResetPasswordToken(resetPasswordToken) {
    return this.makeRequest(this.httpClient
      .get(this.apiEndPointsBuilder.validateResetPasswordToken(resetPasswordToken)));
  }

  sendResetPasswordRequest(email) {
    return this.makeRequest(this.httpClient
      .post(this.apiRoutes.accountResetPasswordRequest, email));
  }

  resetPassword(resetPasswordInfo) {
    return this.makeRequest(this.httpClient
      .post(this.apiRoutes.accountResetPassword, resetPasswordInfo));
  }
}

export default AccountService;
